






export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    color: {
      type: String,
    }
  },

  computed: {
    svgStyle() {
      const color = this.color || `rgba(0,0,0,0.4)`
      return `width: ${this.width}px; height: ${this.height}px; stroke: ${color}`
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/javascript/components/evaluation_graph/d3_vertical_line.vue